import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { toast } from "react-toastify";

// // Async thunk for get internal tracker for submission
// export const getSubmissionTracker = createAsyncThunk(
//   "get/recruiter/tracker",
//   async (queryString, { rejectWithValue }) => {
//     try {
//       const response = await api.get(
//         `/recruiter/requirement-tracker/?${queryString}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// // Async thunk for create internal Tracker submission
// export const createSubmissiontracker = createAsyncThunk(
//   "create/internal-tracker",
//   async (userData, { rejectWithValue }) => {
//     try {
//       const response = await api.post(
//         "/recruiter/requirement-tracker/",
//         userData
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// // Async thunk for update internal tracker submission
// export const updateSubmissiontracker = createAsyncThunk(
//   "update/internal-tracker",
//   async ({ values, id }, { rejectWithValue }) => {
//     try {
//       const response = await api.put(
//         `/recruiter/requirement-tracker/${id}/`,
//         values
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// // Async thunk for create internal Tracker submisssion candidate
// export const addSubmissionCandidate = createAsyncThunk(
//   "add/candidate/submission",
//   async (userData, { rejectWithValue }) => {
//     try {
//       const response = await api.post(
//         "/recruiter/requirement-candidate-tracker/",
//         userData
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// // Async thunk for get internal tracker one tracker details
// export const getOneSubmissionTracker = createAsyncThunk(
//   "get/recruiter/one/tracker",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await api.get(`/recruiter/requirement-tracker/${id}/`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// Async thunk for get internal tracker for submission
export const getSubmissionTracker = createAsyncThunk(
  "get/recruiter/tracker",
  async (queryString, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/requirements/all/?${queryString}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create internal Tracker submission
export const createSubmissiontracker = createAsyncThunk(
  "create/internal-tracker",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/req/requirements/create/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update internal tracker submission
export const updateSubmissiontracker = createAsyncThunk(
  "update/internal-tracker",
  async ({ values, id }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/req/requirements/update/${id}/`,
        values
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create internal Tracker submisssion candidate
export const addSubmissionCandidate = createAsyncThunk(
  "add/candidate/submission",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/req/requirements/make-submission/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get internal tracker one tracker details
export const getOneSubmissionTracker = createAsyncThunk(
  "get/recruiter/one/tracker",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/requirements/get-by-requirement_id/${id}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update action internal tracker
export const updateActionSubmissiontracker = createAsyncThunk(
  "action/internal-tracker",
  async ({ values, id }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/recruiter/requirement-tracker/${id}/`,
        values
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const submissionCount = createAsyncThunk(
  "submission/count",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/recruiter/requirement-tracker/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for accept submission tracker from ales manager
export const accepteSubmissionTracker = createAsyncThunk(
  "accept/submission/tracker",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        "/req/requirements/get-requirements-assigned-to-recruiter/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all feedback massage
export const getAllFeedbackMassase = createAsyncThunk(
  "get/all/feedback",
  async (subID, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/feedback/${subID}/messages/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all feedback massage
export const addFeedbackMassase = createAsyncThunk(
  "add/feedback",
  async (payloadData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/req/feedback/send/",
        payloadData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const trackerSubmissionSlice = createSlice({
  name: "trackersubmission",
  initialState: {
    data: null,
    postData: null,
    trackerData: null,
    feedbackMassage: null,
    status: "idle",
    oneSubmisionStatus: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSubmissionTracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getSubmissionTracker.fulfilled, (state, action) => {
        state.status = "get_submission_intenal_succeeded";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getSubmissionTracker.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(createSubmissiontracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createSubmissiontracker.fulfilled, (state, action) => {
        state.status = "create_submission_intenal_succeeded";
        state.postData = action.payload;
        toast.success(action.payload?.message);
      })
      .addCase(createSubmissiontracker.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateSubmissiontracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateSubmissiontracker.fulfilled, (state, action) => {
        state.status = "update_submission_intenal_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(updateSubmissiontracker.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(addSubmissionCandidate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addSubmissionCandidate.fulfilled, (state, action) => {
        state.status = "add_candidate_to_submission";
        toast.success(action.payload?.message);
      })
      .addCase(addSubmissionCandidate.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getOneSubmissionTracker.pending, (state) => {
        state.oneSubmisionStatus = "loading";
      })
      .addCase(getOneSubmissionTracker.fulfilled, (state, action) => {
        state.oneSubmisionStatus = "get_one_internal_tracker_succeeded";
        state.trackerData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getOneSubmissionTracker.rejected, (state, action) => {
        state.oneSubmisionStatus = "failed";
        // toast.error(action.payload?.message);
      })
      .addCase(updateActionSubmissiontracker.pending, (state) => {
        state.oneSubmisionStatus = "loading";
      })
      .addCase(updateActionSubmissiontracker.fulfilled, (state, action) => {
        state.oneSubmisionStatus = "update_requirement_tracker_action";
        toast.success(action.payload?.message);
      })
      .addCase(updateActionSubmissiontracker.rejected, (state, action) => {
        state.oneSubmisionStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(accepteSubmissionTracker.pending, (state) => {
        state.oneSubmisionStatus = "loading";
      })
      .addCase(accepteSubmissionTracker.fulfilled, (state, action) => {
        state.oneSubmisionStatus = "accept_submission_from_bdm";
        toast.success(action.payload?.message);
      })
      .addCase(accepteSubmissionTracker.rejected, (state, action) => {
        state.oneSubmisionStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAllFeedbackMassase.pending, (state) => {
        state.oneSubmisionStatus = "loading";
      })
      .addCase(getAllFeedbackMassase.fulfilled, (state, action) => {
        state.oneSubmisionStatus = "get_all_feedback_massage";
        state.feedbackMassage = action.payload;
        toast.success(action.payload?.message);
      })
      .addCase(getAllFeedbackMassase.rejected, (state, action) => {
        state.oneSubmisionStatus = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(addFeedbackMassase.pending, (state) => {
        state.oneSubmisionStatus = "loading";
      })
      .addCase(addFeedbackMassase.fulfilled, (state, action) => {
        state.oneSubmisionStatus = "send_feedback_massage";
        toast.success(action.payload?.message);
      })
      .addCase(addFeedbackMassase.rejected, (state, action) => {
        state.oneSubmisionStatus = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default trackerSubmissionSlice.reducer;
